export const generateStringTimeItems = (
  stepMinutes: number,
  format12h = false
) => {
  const times: string[] = [];
  const totalMinutesInDay = 24 * 60;

  for (let minutes = 0; minutes < totalMinutesInDay; minutes += stepMinutes) {
    let hours = Math.floor(minutes / 60);
    const mins = minutes % 60;

    if (format12h) {
      const period = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // convert 0 to 12
      const time = `${hours.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")} ${period}`;
      times.push(time);
    } else {
      const time = `${hours.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")}`;
      times.push(time);
    }
  }

  return times;
};
